import apiClient from "./apiClient";

export default {
  getMe() {
    return apiClient.get("validate");
  },
  login(data) {
    return apiClient.post("login", data);
  },
  register(data) {
    return apiClient.post("register", data);
  },
  sidebarMenu() {
    return apiClient.get("sidebar-menu");
  },
  updateProfile(data) {
    return apiClient.post("update-profile", data);
  },
  getWilayah(name) {
    return apiClient.get("wilayah", { params: { name: name } });
  },
};
